import script from "./Users.vue?vue&type=script&setup=true&lang=js"
export * from "./Users.vue?vue&type=script&setup=true&lang=js"

export default script